var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDoubleLeftArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 11,
    viewBox: "0 0 11 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.0338 6.2882L1.0339 6.2883L4.8054 10.3192C5.1243 10.6602 5.6474 10.6603 5.9662 10.3192C6.2779 9.9859 6.2779 9.4508 5.9662 9.1176C5.9662 9.1176 5.9662 9.1176 5.9662 9.1176L2.7568 5.6874L5.9661 2.2574L5.9661 2.2574C6.2778 1.9241 6.2779 1.3889 5.9661 1.0557L1.0338 6.2882ZM1.0338 6.2882C0.8767 6.1203 0.8 5.9023 0.8 5.6874C0.8 5.4726 0.8766 5.2548 1.0337 5.0868L1.0338 5.0867M1.0338 6.2882L1.0338 5.0867M1.0338 5.0867L4.8053 1.0557C4.8053 1.0557 4.8053 1.0557 4.8053 1.0557M1.0338 5.0867L4.8053 1.0557M4.8053 1.0557C5.1242 0.7148 5.6472 0.7147 5.9661 1.0557L4.8053 1.0557Z",
    fill: "#535353",
    stroke: "#535353",
    strokeWidth: 0.4
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.0338 6.2882L5.0339 6.2883L8.8054 10.3192C9.1243 10.6602 9.6474 10.6603 9.9662 10.3192C10.2779 9.9859 10.2779 9.4508 9.9662 9.1176C9.9662 9.1176 9.9662 9.1176 9.9662 9.1176L6.7568 5.6874L9.9661 2.2574L9.9661 2.2574C10.2778 1.9241 10.2779 1.3889 9.9661 1.0557L5.0338 6.2882ZM5.0338 6.2882C4.8767 6.1203 4.8 5.9023 4.8 5.6874C4.8 5.4726 4.8766 5.2548 5.0337 5.0868L5.0338 5.0867M5.0338 6.2882L5.0338 5.0867M5.0338 5.0867L8.8053 1.0557C8.8053 1.0557 8.8053 1.0557 8.8053 1.0557M5.0338 5.0867L8.8053 1.0557M8.8053 1.0557C9.1242 0.7148 9.6472 0.7147 9.9661 1.0557L8.8053 1.0557Z",
    fill: "#535353",
    stroke: "#535353",
    strokeWidth: 0.4
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDoubleLeftArrow);
export default __webpack_public_path__ + "static/media/double-left-arrow.1c322feb203ec79294e534c07eb628bc.svg";
export { ForwardRef as ReactComponent };